import React from 'react';
import PropTypes from 'prop-types';
import {scrollToTop} from '~/utils/scrolling';
import {ORDER_ANYTHING as ORDER_ANYTHING_IMAGE_URL} from '~/constants/ResponsiveImageConstants';
import withRouter, {routerPropTypes} from '~/router/withRouter';
import {Typography} from '@customink/pigment-react';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const OrderAnythingCard = ({
  anchorStyle,
  addStylesMetrics = () => {},
  hasComplements = false,
  addItemsPath = false,
  quoteFormPath = false,
  router,
  fireOrderAnythingMetrics
}) => {
  const onButtonClick = () => {
    fireOrderAnythingMetrics();
    const pathPrefix = `/productCatalogOrderMore/${anchorStyle.id}/`;
    let [pathParam, iframePath] = '';
    if (addItemsPath) pathParam = 'addItemsPath=true';
    if (quoteFormPath) pathParam = 'quoteFormPath=true';
    iframePath = pathParam ? `${pathPrefix}?${pathParam}` : pathPrefix;
    scrollToTop(document.body, router.navigate(iframePath));
    addStylesMetrics({hasComplements});
  };

  return (
    <div
      className="ndx-OrderAnythingCard ndx-OrderAnythingCard--small"
      onClick={onButtonClick}
      data-testid="order-anything-card">
      <img
        className="ndx-OrderAnythingCard-image"
        src={ORDER_ANYTHING_IMAGE_URL}
      />
      <Typography
        variant="uiTextDefault"
        key="details"
        className="ndx-OrderAnythingCard-details">
        More products that your group will love
      </Typography>
      <Typography
        variant="uiTextSmall"
        component="button"
        className="ndx-cta-Tertiary">
        Browse More
      </Typography>
    </div>
  );
};

OrderAnythingCard.displayName = 'OrderAnythingCard';

const propTypes = {
  addItemsPath: PropTypes.bool,
  addStylesMetrics: PropTypes.func,
  anchorStyle: PropTypes.object,
  fireOrderAnythingMetrics: PropTypes.func,
  hasComplements: PropTypes.bool,
  quoteFormPath: PropTypes.bool,
  router: routerPropTypes
};

OrderAnythingCard.propTypes = propTypes;

export default withRouter(OrderAnythingCard);
